import { useQuery } from '@tanstack/react-query';

export function usePlanesOdont() {
  return useQuery({
    queryKey: ['planes-odont'],
    queryFn: async () => {
      const res = await fetch('/api/planes-odont');
      if (!res.ok) throw new Error('Error al obtener los planes odontológicos');
      const data = await res.json();
      // Siempre normaliza a array
      return Array.isArray(data.CARTILLA) ? data.CARTILLA : [data.CARTILLA];
    },
    staleTime: 1000 * 60 * 60, // 1 hora
  });
} 